import "./RootNode.css";

import {
  ApplicationIcon,
  Avatar,
  Badge,
  Icon,
  Typography,
} from "@saviynt/design-system";
import { Handle, Position } from "@xyflow/react";
import { useMemo } from "react";
import { useIntl } from "react-intl";

import { type NodeData } from "../../types";
import { IconMap } from "../IconMap";
import { TextWrapper } from "../TextWrapper";
import { getApplicationSourceIcon } from "../../../PoliciesSidepanel/PoliciesSidepanel";

export default function RootNode({ data }: { data: NodeData }) {
  const intl = useIntl();

  const {
    policyViolationCount,
    label,
    displayName,
    isLeftSectionExist,
    isRightSectionExist,
    onNodeClick,
    source,
    type: resourceType,
    isOpenToAllInternet,
  } = data;

  const badgeElement = useMemo(
    () =>
      policyViolationCount ? (
        <Badge
          kind="number"
          className="node-badge"
          number={policyViolationCount}
          color="error"
          size="medium"
        />
      ) : null,
    [policyViolationCount],
  );

  const sourceElement = useMemo(
    () =>
      source ? (
        <div className="source-badge">
          <ApplicationIcon
            logo={getApplicationSourceIcon(source)}
            size="small"
          />
        </div>
      ) : null,
    [source],
  );

  return (
    <div className="Nhi-AccessMap-root-node" onClick={() => onNodeClick(data)}>
      <div className="node-icon-container">
        {isLeftSectionExist && (
          <Handle
            type="target"
            position={Position.Left}
            style={{
              position: "absolute",
              top: "44px",
              left: "-12px",
            }}
          />
        )}
        {isRightSectionExist && (
          <Handle
            type="source"
            position={Position.Right}
            style={{
              position: "absolute",
              top: "44px",
              right: "-12px",
            }}
          />
        )}
        <div className={`node-icon ${policyViolationCount ? "error" : ""}`}>
          <IconMap source={`${label}s`} size="xLarge" />
        </div>
        {badgeElement}
        {sourceElement}
      </div>

      <TextWrapper label={displayName} subLabel={resourceType} />
      {isOpenToAllInternet ? (
        <div className="openTtoAllPublicNetwork">
          <Avatar size="medium">
            <Icon kind="Globe" />
          </Avatar>
          <Typography kind="body2">
            {intl.formatMessage({
              defaultMessage: "Open To All Public Internet",
              id: "vZbeJF",
              description: "Open To All Public Internet",
            })}
          </Typography>
        </div>
      ) : null}
    </div>
  );
}
